(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.sbpReady === '1') return;
    root.dataset.sbpReady = '1';

    const q = (s, el) => (el || root).querySelector(s);
    const qa = (s, el) => Array.from((el || root).querySelectorAll(s));

    let fmt;
    try {
      fmt = new Intl.NumberFormat(root.dataset.locale || undefined, { style: 'currency', currency: root.dataset.currency || 'USD' });
    } catch (e) {
      fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    }
    const money = (cents) => fmt.format(cents / 100);
    const motion = () => (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');

    const pcards = qa('[data-printer]');
    const panels = qa('[data-panel]');
    const el = {
      pick: q('[data-pick]'), builder: q('[data-builder]'), empty: q('[data-empty]'), tabs: q('[data-tabs]'),
      selImg: q('[data-sel-img]'), selName: q('[data-sel-name]'), selBrand: q('[data-sel-brand]'),
      list: q('[data-list]'), total: q('[data-total]'), meter: q('[data-meter]'), inst: q('[data-inst]'),
      checkout: q('[data-checkout]'), mText: q('[data-mtext]'), aside: q('[data-aside]'),
      toast: q('[data-toast]'), noRes: q('[data-noresults]')
    };
    const S = { active: null, tab: null, type: 'all', brand: null };

    const panelFor = (id) => panels.find((p) => p.dataset.panel === id) || null;
    const pcardFor = (id) => pcards.find((c) => c.dataset.printer === id) || null;
    const panel = () => (S.active ? panelFor(S.active) : null);
    const groupsOf = (p) => (p ? qa('[data-group-section]', p) : []);
    const selected = () => { const p = panel(); return p ? qa('[data-card].is-on', p) : []; };
    const variantOf = (card) => {
      const v = q('[data-variant]', card);
      const opt = v.tagName === 'SELECT' ? v.selectedOptions[0] : v;
      return { id: Number(v.value), price: Number(opt.dataset.price), label: v.tagName === 'SELECT' ? opt.textContent.trim() : '' };
    };

    let toastTimer;
    function toast(msg) {
      el.toast.textContent = msg;
      el.toast.classList.add('is-show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => el.toast.classList.remove('is-show'), 2800);
    }

    function setOn(card, on) {
      card.classList.toggle('is-on', on);
      const b = q('[data-toggle]', card);
      if (b) {
        b.setAttribute('aria-pressed', String(on));
        b.textContent = on ? b.dataset.onLabel : b.dataset.label;
      }
    }

    function updatePrice(card) {
      q('[data-price-display]', card).textContent = money(variantOf(card).price);
    }

    function filter() {
      let shown = 0;
      pcards.forEach((c) => {
        const ok = (S.type === 'all' || c.dataset.type === S.type) && (!S.brand || c.dataset.brand === S.brand);
        c.hidden = !ok;
        if (ok) shown++;
      });
      if (el.noRes) el.noRes.hidden = shown > 0;
    }

    function markPrinters() {
      pcards.forEach((c) => {
        const on = c.dataset.printer === S.active;
        c.setAttribute('aria-pressed', String(on));
        const btn = q('.dtfg-sbp__pick-btn', c);
        if (btn) btn.textContent = on ? btn.dataset.on : btn.dataset.off;
      });
    }

    function renderTabs() {
      el.tabs.replaceChildren();
      groupsOf(panel()).forEach((g) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'dtfg-sbp__tab';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', String(g.dataset.key === S.tab));
        b.dataset.tab = g.dataset.key;
        b.append(document.createTextNode(g.dataset.nav));
        const n = qa('[data-card].is-on', g).length;
        if (n) {
          const c = document.createElement('span');
          c.className = 'dtfg-sbp__tabcount';
          c.textContent = String(n);
          b.append(c);
        }
        el.tabs.append(b);
      });
    }

    function showTab(key, scroll) {
      const groups = groupsOf(panel());
      if (!groups.length) return;
      let idx = groups.findIndex((g) => g.dataset.key === key);
      if (idx < 0) idx = 0;
      S.tab = groups[idx].dataset.key;
      groups.forEach((g, i) => {
        g.hidden = i !== idx;
        const nx = q('[data-next]', g);
        if (!nx) return;
        const next = groups[i + 1];
        if (next) {
          nx.hidden = false;
          nx.dataset.target = next.dataset.key;
          nx.textContent = 'Next: ' + next.dataset.nav + ' →';
        } else {
          nx.hidden = true;
        }
      });
      renderTabs();
      if (scroll) {
        const top = el.builder.getBoundingClientRect().top;
        if (top < 0) el.builder.scrollIntoView({ behavior: motion(), block: 'start' });
      }
    }

    function choose(id, silent) {
      const p = panelFor(id);
      if (!p) {
        console.warn('[DTFG Shop by Printer] No product panel found for printer block:', id);
        return;
      }
      if (id === S.active) {
        if (!silent) el.builder.scrollIntoView({ behavior: motion(), block: 'start' });
        return;
      }

      const oldP = panel();
      const carry = oldP
        ? qa('[data-card].is-on:not([data-group="bundle"])', oldP).map((c) => ({ pid: c.dataset.productId, vid: q('[data-variant]', c).value }))
        : [];
      if (oldP) qa('[data-card].is-on', oldP).forEach((c) => setOn(c, false));

      S.active = id;
      markPrinters();
      panels.forEach((x) => { x.hidden = x !== p; });
      el.empty.hidden = true;
      el.builder.hidden = false;

      const firstBundle = qa('[data-group="bundle"]', p).find((c) => q('[data-toggle]', c));
      if (firstBundle) setOn(firstBundle, true);

      let dropped = 0;
      carry.forEach((it) => {
        const c = q('[data-card][data-product-id="' + it.pid + '"]:not([data-group="bundle"])', p);
        if (c && q('[data-toggle]', c)) {
          const v = q('[data-variant]', c);
          if (v.tagName === 'SELECT') { v.value = it.vid; updatePrice(c); }
          setOn(c, true);
        } else {
          dropped++;
        }
      });

      const pc = pcardFor(id);
      el.selName.textContent = pc ? pc.dataset.name : '';
      el.selBrand.textContent = pc ? pc.dataset.brand : '';
      const img = pc ? q('img', pc) : null;
      if (img) { el.selImg.src = img.currentSrc || img.src; el.selImg.hidden = false; }
      else { el.selImg.hidden = true; }

      showTab('bundle', false);
      render();

      if (silent) return;
      const name = pc ? pc.dataset.name : 'this printer';
      toast(dropped
        ? 'Switched to ' + name + '. Removed ' + dropped + ' item' + (dropped > 1 ? 's' : '') + " that don't fit it."
        : 'Showing everything for ' + name);
      el.builder.scrollIntoView({ behavior: motion(), block: 'start' });
    }

    function clearPrinter() {
      const p = panel();
      if (p) qa('[data-card].is-on', p).forEach((c) => setOn(c, false));
      S.active = null;
      S.tab = null;
      markPrinters();
      panels.forEach((x) => { x.hidden = true; });
      el.builder.hidden = true;
      el.empty.hidden = false;
      el.aside.classList.remove('is-open');
      render();
      el.pick.scrollIntoView({ behavior: motion(), block: 'start' });
    }

    function render() {
      const items = selected();

      el.list.replaceChildren();
      let total = 0;
      if (!items.length) {
        const li = document.createElement('li');
        li.className = 'dtfg-sbp__tempty';
        li.textContent = root.dataset.emptyCart;
        el.list.append(li);
      }
      items.forEach((c, i) => {
        const v = variantOf(c);
        total += v.price;
        const li = document.createElement('li');
        const name = document.createElement('span');
        name.className = 'dtfg-sbp__tname';
        name.textContent = c.dataset.title + (v.label ? ' (' + v.label + ')' : '');
        const right = document.createElement('span');
        right.className = 'dtfg-sbp__tright';
        right.append(document.createTextNode(money(v.price)));
        const x = document.createElement('button');
        x.type = 'button';
        x.className = 'dtfg-sbp__x';
        x.dataset.remove = String(i);
        x.setAttribute('aria-label', 'Remove ' + c.dataset.title);
        x.textContent = '×';
        right.append(x);
        li.append(name, right);
        el.list.append(li);
      });

      el.total.textContent = money(total);

      el.meter.replaceChildren();
      if (root.dataset.meter === 'true' && items.length) {
        const need = Number(root.dataset.meterCount) || 4;
        const pct = root.dataset.meterPercent;
        const n = items.length;
        const t = document.createElement('p');
        if (n >= need) {
          t.className = 'is-done';
          t.textContent = pct + '% setup discount applies at checkout';
          el.meter.append(t);
        } else {
          t.textContent = 'Add ' + (need - n) + ' more item' + (need - n > 1 ? 's' : '') + ' to save ' + pct + '% on your setup';
          const bar = document.createElement('div');
          bar.className = 'dtfg-sbp__bar';
          const fill = document.createElement('i');
          fill.style.width = (n / need) * 100 + '%';
          bar.append(fill);
          el.meter.append(t, bar);
        }
      }

      el.inst.textContent = root.dataset.inst === 'true' && total ? 'or 4 payments of ' + money(total / 4) : '';
      el.checkout.disabled = !items.length;
      el.checkout.textContent = root.dataset.checkoutLabel + (items.length ? ' (' + items.length + ')' : '');
      el.mText.textContent = items.length + ' item' + (items.length === 1 ? '' : 's') + ' · ' + money(total);
      renderTabs();
    }

    async function addAll() {
      const items = selected().map((c) => ({ id: variantOf(c).id, quantity: 1 }));
      if (!items.length) return;
      const label = el.checkout.textContent;
      el.checkout.disabled = true;
      el.checkout.textContent = 'Adding…';
      const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        const res = await fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart. Please try again.');
        window.location.href = root.dataset.after === 'checkout' ? base + 'checkout' : base + 'cart';
      } catch (err) {
        toast(err.message);
        el.checkout.disabled = false;
        el.checkout.textContent = label;
      }
    }

    root.addEventListener('click', (e) => {
      const t = e.target.closest('button');
      if (!t || !root.contains(t)) return;

      if (t.hasAttribute('data-printer')) { choose(t.dataset.printer, false); return; }

      if (t.hasAttribute('data-toggle')) {
        const card = t.closest('[data-card]');
        if (!card) return;
        if (card.dataset.group === 'bundle') {
          if (card.classList.contains('is-on')) return;
          qa('[data-group="bundle"]', panel()).forEach((c) => setOn(c, false));
          setOn(card, true);
          toast('Package selected: ' + card.dataset.title);
        } else {
          const on = !card.classList.contains('is-on');
          setOn(card, on);
          if (on) toast('Added ' + card.dataset.title);
        }
        render();
        return;
      }

      if (t.hasAttribute('data-remove')) {
        const card = selected()[Number(t.dataset.remove)];
        if (!card) return;
        if (card.dataset.group === 'bundle') { clearPrinter(); return; }
        setOn(card, false);
        render();
        return;
      }

      if (t.hasAttribute('data-tab')) { showTab(t.dataset.tab, true); return; }
      if (t.hasAttribute('data-next')) { showTab(t.dataset.target, true); return; }

      if (t.hasAttribute('data-filter-type')) {
        S.type = t.dataset.filterType;
        qa('[data-filter-type]').forEach((x) => x.setAttribute('aria-pressed', String(x === t)));
        filter();
        return;
      }
      if (t.hasAttribute('data-filter-brand')) {
        S.brand = S.brand === t.dataset.filterBrand ? null : t.dataset.filterBrand;
        qa('[data-filter-brand]').forEach((x) => x.setAttribute('aria-pressed', String(x.dataset.filterBrand === S.brand)));
        filter();
        return;
      }

      if (t.hasAttribute('data-change')) { el.pick.scrollIntoView({ behavior: motion(), block: 'start' }); return; }
      if (t.hasAttribute('data-checkout')) { addAll(); return; }
      if (t.hasAttribute('data-open')) { el.aside.classList.add('is-open'); return; }
      if (t.hasAttribute('data-close')) { el.aside.classList.remove('is-open'); return; }
    });

    root.addEventListener('change', (e) => {
      const sel = e.target.closest('[data-variant]');
      if (!sel) return;
      const card = sel.closest('[data-card]');
      updatePrice(card);
      if (card.classList.contains('is-on')) render();
    });

    root._sbpChoose = (id) => choose(id, true);
    render();
  }

  function boot() { document.querySelectorAll('.dtfg-sbp').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('.dtfg-sbp')));
  document.addEventListener('shopify:block:select', (e) => {
    const root = e.target.closest && e.target.closest('.dtfg-sbp');
    if (root && root._sbpChoose && e.target.hasAttribute('data-printer')) root._sbpChoose(e.target.dataset.printer);
  });
})();